// @ts-nocheck
import React from "react";
import {useNavigate} from "react-router-dom";
import fallbackImage from "../../../../../assets/images/fallback-image.svg";
import CasinoImg from "../../../../../assets/images/home-games-display/casino.webp";
import {useAuthStore} from "../../../../../store/useAuth.store";
import {useMiniGames} from "../../../../../store/useMiniGames";
import {
  displayCharacterCls,
  displayCharBtnCls,
  displayCharOverlayCls,
  displayCharTitleCls,
  displayGameCardCls,
  displayGameCardLoadingCls,
  displayGameCardOverlayCls,
  displayGameCardPlayCls,
  displayGameIconCls,
  displayLeftCls,
  displayRightCls,
  displayRowCls,
  displaySectionNoTop,
} from "../_displayShared";

const CasinoDisplay = () => {
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  const allGames = useMiniGames(state => state.list);
  const isLoading = useMiniGames(state => state.loading);

  const topCasino = React.useMemo(() => {
    if (!allGames.length) return [];
    return allGames.filter(game => game.class === "live games").slice(0, 12);
  }, [allGames]);

  const row1 = topCasino.slice(0, 6);
  const row2 = topCasino.slice(6, 12);
  const placeholders = Array.from({length: 6});

  const renderCard = (game, idx) =>
    game ? (
      <div
        key={game.id || idx}
        className={displayGameCardCls}
        onClick={() =>
          authStatus === "authenticated" ? navigate(`/games/${game.provider}/${game.id}`) : handleShowAuthModal()
        }
      >
        <img
          src={game.icon || fallbackImage}
          alt={game.name}
          onError={e => {
            e.target.onerror = null;
            e.target.src = fallbackImage;
          }}
          className={displayGameIconCls}
        />
        <div
          className={displayGameCardOverlayCls}
          aria-hidden="true"
        >
          <span className={displayGameCardPlayCls}>▶</span>
        </div>
      </div>
    ) : (
      <div
        key={`ph-${idx}`}
        className={`${displayGameCardCls} ${displayGameCardLoadingCls}`}
      />
    );

  return (
    <div className={displaySectionNoTop}>
      {/* Left: image with overlay */}
      <div className={displayLeftCls}>
        <img
          src={CasinoImg}
          alt="Casino background"
          className={displayCharacterCls}
        />
        <div className={displayCharOverlayCls}>
          <span className={displayCharTitleCls}>Live Casino</span>
          <button
            className={displayCharBtnCls}
            type="button"
            onClick={() =>
              authStatus === "authenticated" ? navigate("/casino") : handleShowAuthModal()
            }
          >
            Ir a todos
          </button>
        </div>
      </div>

      {/* Right: 6×2 grid */}
      <div className={displayRightCls}>
        <div className={displayRowCls}>
          {(isLoading || !topCasino.length ? placeholders : row1).map((g, i) => renderCard(g, i))}
        </div>
        <div className={displayRowCls}>
          {(isLoading || !topCasino.length ? placeholders : row2).map((g, i) => renderCard(g, i + 6))}
        </div>
      </div>
    </div>
  );
};

export default CasinoDisplay;
